import { render, staticRenderFns } from "./SubmissionReviewFormRatingsMultiCategory.vue?vue&type=template&id=410ba868&scoped=true&"
import script from "./SubmissionReviewFormRatingsMultiCategory.vue?vue&type=script&lang=js&"
export * from "./SubmissionReviewFormRatingsMultiCategory.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionReviewFormRatingsMultiCategory.vue?vue&type=style&index=0&id=410ba868&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410ba868",
  null
  
)

export default component.exports